import { forwardRef, ReactNode } from 'react'

import { IRichRun } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

import { RichRunsText } from './styled'

type RichRunsProps = {
  runs: IRichRun[]
  clamped?: boolean
}

// QRM-640: declaration runs → elements. The runs are plain styled text segments
// produced server-side from the CashAssist RTF ("\n" = paragraph break, rendered
// via white-space: pre-line) — never HTML, so nothing here parses or sanitizes.
// QRM-662: one <p> holds every run, which is what lets -webkit-line-clamp work
// on the whole declaration rather than on a single segment.
export const RichRuns = forwardRef<HTMLParagraphElement, RichRunsProps>(
  ({ runs, clamped }, ref) => (
    <RichRunsText ref={ref} $clamped={clamped}>
      {runs.map((run, idx) => {
        let node: ReactNode = run.text
        if (run.underline) node = <u>{node}</u>
        if (run.italic) node = <em>{node}</em>
        if (run.bold) node = <b>{node}</b>
        return <span key={`run_${idx}`}>{node}</span>
      })}
    </RichRunsText>
  )
)
